<template>
    <div class="cusModal" v-if="showtable">
        <div class="cusModalCont">
            <div class="cusModalTitle backBlack">
                {{ title }} - {{ path_info.card_id }}
                <div class="cusModalClose" @click="closeTable()">{{ lang.close }}</div>
            </div>
            <div class="cusModalBody">
                <div class="buttonArea">
                    <div class="eportBtn">
                        <div style="background:darkblue;color:#fff;" @click="showAttached()" v-b-toggle.add_gallery>{{ lang.attachement }}</div>
                        <div style="background:darkslateblue;color:#fff;" @click="sendCardToCustomer()">{{ lang.send_job_card_to_customer }}</div>
                        <div style="background:darkgreen;color:#fff;" @click="sendSelection()">{{ lang.send_selected_to_customer }}</div>
                        <div style="background:darkmagenta;color:#fff;" @click="addInvoice()" v-if="path_info.invoice_id == 0" v-b-toggle.add_invoice>{{ lang.create_invoice }}</div>
                        <div style="background:darkmagenta;color:#fff;" @click="printInv()" v-else>{{ lang.print_invoice }}</div>
                        <div style="background:burlywood;color:#fff;display:none;" @click="addBInvoice()" v-b-toggle.add_black_invoice>{{ lang.issue_draft_invoice }}</div>
                        <div style="background:darkslategray;color:#fff;" @click="requestSparePart()" v-b-toggle.req_sparepart>{{ lang.request_spare_parts }}</div>
                        <div style="background:darkslategray;color:#fff;" @click="addToService()" v-b-toggle.add_service>{{ lang.add_labor_work }}</div>
                        <div style="background:darkorange;color:#fff;" @click="addToStore(2)" v-b-toggle.add_sparepart>{{ lang.add_spare_parts_unbilled }}</div>
                        <div style="background:darkred;color:#fff;" @click="addToStore(1)" v-b-toggle.add_sparepart>{{ lang.add_spare_parts_billed }}</div>
                        <div style="background:green;color:white;" @click="printMe()">{{ lang.print }}</div>
                    </div>
                </div>
                <v-row style="padding-inline:10px;margin-inline: 10px;">
                    <v-col cols="12" sm="12" md="6">
                        <b-table-simple>
                            <thead>
                                <th class="backBlack text-center">{{ lang.customer_name }}</th>
                                <th class="backBlack text-center">{{ lang.mobile }}</th>
                                <th class="backBlack text-center">{{ lang.vat_number }}</th>
                                <th class="backBlack text-center">{{ lang.crt_number }}</th>
                                <th class="backBlack text-center">{{ lang.status }}</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ path_info.customer.customer_name }}</td>
                                    <td class="text-center">{{ path_info.customer.mobile }}</td>
                                    <td class="text-center">{{ path_info.customer.vat_number }}</td>
                                    <td class="text-center">{{ path_info.customer.crt_number }}</td>
                                    <td class="text-center" style="width:100px;">
                                        <b-input-group>
                                        <b-form-select
                                            class="selborder"
                                            v-model="path_info.status"
                                            :options="pathStatus"
                                            @change="changeStatus()"
                                            ></b-form-select>
                                        <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                            <i class="fas fa-arrow-down"></i>
                                            </b-input-group-append>
                                        </b-input-group>
                                    
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                        <b-table-simple v-if="path_info.contact_person != ''">
                            <thead>
                                <th class="backBlack text-center">{{ lang.contact_person }}</th>
                                <th class="backBlack text-center">{{ lang.contact_person_mobile }}</th>
                                <th class="backBlack text-center">{{ lang.who_will_contact }}</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ path_info.contact_person }}</td>
                                    <td class="text-center">{{ path_info.contact_person_mobile }}</td>
                                    <td class="text-center">{{ path_info.who_will_contact }}</td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <b-table-simple>
                            <thead>
                                <th class="backBlack text-center">{{ lang.plate_number }}</th>
                                <th class="backBlack text-center">{{ lang.brand }}</th>
                                <th class="backBlack text-center">{{ lang.model }}</th>
                                <th class="backBlack text-center">{{ lang.car_year }}</th>
                                <th class="backBlack text-center">{{ lang.vin }}</th>
                                <th class="backBlack text-center">{{ lang.engine_meter }}</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ path_info.plate_number }}</td>
                                    <td class="text-center">{{ path_info.brand }}</td>
                                    <td class="text-center">{{ path_info.model }}</td>
                                    <td class="text-center">{{ path_info.made_year }}</td>
                                    <td class="text-center">{{ path_info.vin }}</td>
                                    <td class="text-center">{{ path_info.engine_meter }}</td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <div style="background:black;color:white;padding:5px;">{{ lang.items_for_customer_approval }}</div>
                        <b-table-simple>
                            <thead>
                                <th class="backBlack text-center" style="width:50px;" v-if="path_info.items_to_approve.length != 0">
                                    <b-form-checkbox v-model="selectAllChecked"
                                    @change="selectAll()" /></th>
                                <th class="backBlack text-center">{{ lang.type }}</th>
                                <th class="backBlack text-center">{{ lang.added_date }}</th>
                                <th class="backBlack text-center">{{ lang.item_code }}</th>
                                <th class="backBlack text-center">{{ lang.item_name }}</th>
                                <th class="backBlack text-center">{{ lang.price }}</th>
                                <th class="backBlack text-center">{{ lang.qtty }}</th>
                                <th class="backBlack text-center">{{ lang.total }}</th>
                                <th class="backBlack text-center">{{ lang.vat }}</th>
                                <th class="backBlack text-center">{{ lang.ftotal }}</th>
                                <!-- <th class="backBlack text-center">{{ lang.status }}</th> -->
                                <th class="backRed text-center" style="width:80px;">{{ lang.return }}</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in path_info.items_to_approve" :key="index">
                                    <td class="text-center"><b-form-checkbox v-model="selectedItems"
                                        :ref="`item_${item.id}`" :value="item.id" @click.stop="toggleRowSelection(item.id)" /></td>
                                    <td class="text-center" v-if="item.part_type == 2">{{ lang.service_item }}</td>
                                    <td class="text-center" v-if="item.part_type == 1">{{ lang.inventory_item }}</td>
                                    <td class="text-center">{{ item.added_date }}</td>
                                    <td class="text-center">{{ item.item_code }}</td>
                                    <td class="text-center" v-if="item[`item_name${lang.langname}`] != ''">{{ item[`item_name${lang.langname}`] }} <div v-html="item.description"></div></td>
                                    <td class="text-center" v-else>{{ item[`item_name_desc`] }} <div v-html="item.description"></div></td>
                                    <td class="text-center">{{ item.item_price }}</td>
                                    <td class="text-center">{{ item.qty }}</td>
                                    <td class="text-center">{{ item.total }}</td>
                                    <td class="text-center">{{ item.vat }}</td>
                                    <td class="text-center">{{ item.ftotal }}</td>
                                    <!-- <td class="text-center">{{ item.status }}</td> -->
                                    <td class="backRed text-center" style="cursor:pointer;" @click="deleteThis1('items_to_approve', item.id)">
                                        {{ lang.return }}
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <div style="background:black;color:white;padding:5px;">{{ lang.spare_parts_requests }}</div>
                        <b-table-simple>
                            <thead>
     
                                <th class="backBlack text-center">{{ lang.type }}</th>
                                <th class="backBlack text-center">{{ lang.added_date }}</th>
                                <th class="backBlack text-center">{{ lang.item_code }}</th>
                                <th class="backBlack text-center">{{ lang.item_name }}</th>
                                <th class="backBlack text-center">{{ lang.price }}</th>
                                <th class="backBlack text-center">{{ lang.qtty }}</th>
                                <th class="backBlack text-center">{{ lang.total }}</th>
                                <th class="backBlack text-center">{{ lang.vat }}</th>
                                <th class="backBlack text-center">{{ lang.ftotal }}</th>
                                <!-- <th class="backBlack text-center">{{ lang.status }}</th> -->
                                <th class="backRed text-center" style="width:80px;">{{ lang.return }}</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in path_info.items_requested" :key="index">
                                    <td class="text-center" v-if="item.part_type == 2">{{ lang.service_item }}</td>
                                    <td class="text-center" v-if="item.part_type == 1">{{ lang.inventory_item }}</td>
                                    <td class="text-center">{{ item.added_date }}</td>
                                    <td class="text-center">{{ item.item_code }}</td>
                                    <td class="text-center" v-if="item[`item_name${lang.langname}`] != ''">{{ item[`item_name${lang.langname}`] }}</td>
                                    <td class="text-center" v-else>{{ item[`item_name_desc`] }}</td>
                                    <td class="text-center">{{ item.item_price }}</td>
                                    <td class="text-center">{{ item.qty }}</td>
                                    <td class="text-center">{{ item.total }}</td>
                                    <td class="text-center">{{ item.vat }}</td>
                                    <td class="text-center">{{ item.ftotal }}</td>
                                    <!-- <td class="text-center">{{ item.status }}</td> -->
                                    <td class="backRed text-center" style="cursor:pointer;" @click="deleteThis1('item_requested', item.id)">
                                        {{ lang.return }}
                                    </td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <div style="background:black;color:white;padding:5px;">{{ lang.service_work_item }}</div>
                        <b-table-simple>
                            <thead>
                                <!-- <th class="backBlack text-center" style="width:50px;"></th> -->
                                <th class="backBlack text-center">{{ lang.added_date }}</th>
                                <th class="backBlack text-center">{{ lang.item_code }}</th>
                                <th class="backBlack text-center">{{ lang.item_name }}</th>
                                <th class="backBlack text-center">{{ lang.price }}</th>
                                <th class="backBlack text-center">{{ lang.qtty }}</th>
                                <th class="backBlack text-center">{{ lang.total }}</th>
                                <th class="backBlack text-center">{{ lang.vat }}</th>
                                <th class="backBlack text-center">{{ lang.ftotal }}</th>
                                <!-- <th class="backBlack text-center">{{ lang.status }}</th> -->
                                <th class="backRed text-center" style="width:80px;">{{ lang.return }}</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in path_info.items[0][1]" :key="index">
                                    <!-- <td class="text-center"><b-form-checkbox @change="selectThis(item.id)" /></td> -->
                                    <td class="text-center">{{ item.added_date }}</td>
                                    <td class="text-center">{{ item.item_code }}</td>
                                    <td class="text-center" v-if="item[`item_name${lang.langname}`] != ''">{{ item[`item_name${lang.langname}`] }} <div v-html='item.description'></div></td>
                                    <td class="text-center" v-else>{{ item[`item_name_desc`] }}<div v-html='item.description'></div></td>
                                    <td class="text-center">{{ item.item_price }}</td>
                                    <td class="text-center">{{ item.qty }}</td>
                                    <td class="text-center">{{ item.total }}</td>
                                    <td class="text-center">{{ item.vat }}</td>
                                    <td class="text-center">{{ item.ftotal }}</td>
                                    <!-- <td class="text-center">{{ item.status }}</td> -->
                                    <td class="backRed text-center" style="cursor:pointer;" @click="deleteThis1('service_item', item.id)">{{ lang.return }}</td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <div style="background:black;color:white;padding:5px;">{{ lang.spare_part_included_in_invoice }}</div>
                        <b-table-simple>
                            <thead>
                                <!-- <th class="backBlack text-center" style="width:50px;"></th> -->
                                <th class="backBlack text-center">{{ lang.part_type }}</th>
                                <th class="backBlack text-center">{{ lang.added_date }}</th>
                                <th class="backBlack text-center">{{ lang.item_code }}</th>
                                <th class="backBlack text-center">{{ lang.item_name }}</th>
                                <th class="backBlack text-center">{{ lang.price }}</th>
                                <th class="backBlack text-center">{{ lang.qtty }}</th>
                                <th class="backBlack text-center">{{ lang.total }}</th>
                                <th class="backBlack text-center">{{ lang.vat }}</th>
                                <th class="backBlack text-center">{{ lang.ftotal }}</th>
                                <!-- <th class="backBlack text-center">{{ lang.status }}</th> -->
                                <th class="backRed text-center" style="width:80px;">{{ lang.return }}</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in path_info.items[1][1]" :key="index">
                                    <!-- <td class="text-center"><b-form-checkbox @change="selectThis(item.id)" /></td> -->
                                    <td class="text-center" v-if="item.part_type == 1">{{ lang.from_inventory }}</td>
                                    <td class="text-center" v-else>{{ lang.from_out_of_store }}</td>
                                    <td class="text-center">{{ item.added_date }}</td>
                                    <td class="text-center">{{ item.item_code }}</td>
                                    <td class="text-center" v-if="item[`item_name${lang.langname}`] != ''">{{ item[`item_name${lang.langname}`] }}<div v-html='item.description'></div></td>
                                    <td class="text-center" v-else>{{ item[`item_name_desc`] }}<div v-html='item.description'></div></td>
                                    <td class="text-center">{{ item.item_price }}</td>
                                    <td class="text-center">{{ item.qty }}</td>
                                    <td class="text-center">{{ item.total }}</td>
                                    <td class="text-center">{{ item.vat }}</td>
                                    <td class="text-center">{{ item.ftotal }}</td>
                                    <!-- <td class="text-center">{{ item.status }}</td> -->
                                    <td class="backRed text-center" style="cursor:pointer;" @click="deleteThis1('spare_part_invoice', item.id)">{{ lang.return }}</td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <div style="background:black;color:white;padding:5px;">{{ lang.spare_part_not_included_in_invoice }}</div>
                        <b-table-simple>
                            <thead>
                                <!-- <th class="backBlack text-center" style="width:50px;"></th> -->
                                <th class="backBlack text-center">{{ lang.part_type }}</th>
                                <th class="backBlack text-center">{{ lang.added_date }}</th>
                                <th class="backBlack text-center">{{ lang.item_code }}</th>
                                <th class="backBlack text-center">{{ lang.item_name }}</th>
                                <th class="backBlack text-center">{{ lang.price }}</th>
                                <th class="backBlack text-center">{{ lang.qtty }}</th>
                                <th class="backBlack text-center">{{ lang.total }}</th>
                                <th class="backBlack text-center">{{ lang.vat }}</th>
                                <th class="backBlack text-center">{{ lang.ftotal }}</th>
                                <!-- <th class="backBlack text-center">{{ lang.status }}</th> -->
                                <th class="backRed text-center" style="width:80px;">{{ lang.return }}</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in path_info.items[1][2]" :key="index">
                                    <!-- <td class="text-center"><b-form-checkbox @change="selectThis(item.id)" /></td> -->
                                    <td class="text-center">{{ lang.from_inventory }}</td>
                                    <td class="text-center">{{ item.added_date }}</td>
                                    <td class="text-center">{{ item.item_code }}</td>
                                    <td class="text-center" v-if="item[`item_name${lang.langname}`] != ''">{{ item[`item_name${lang.langname}`] }}<div v-html='item.description'></div></td>
                                    <td class="text-center" v-else>{{ item[`item_name_desc`] }}<div v-html='item.description'></div></td>
                                    <td class="text-center">{{ item.item_price }}</td>
                                    <td class="text-center">{{ item.qty }}</td>
                                    <td class="text-center">{{ item.total }}</td>
                                    <td class="text-center">{{ item.vat }}</td>
                                    <td class="text-center">{{ item.ftotal }}</td>
                                    <!-- <td class="text-center">{{ item.status }}</td> -->
                                    <td class="backRed text-center" style="cursor: pointer;" @click="deleteThis1('spare_part_not_invoice', item.id)">{{ lang.return }}</td>
                                </tr>
                                <tr v-for="(item,index) in path_info.items[1][4]" :key="index">
                                    <!-- <td class="text-center"><b-form-checkbox @change="selectThis(item.id)" /></td> -->
                                    <td class="text-center">{{ lang.from_out_of_store }}</td>
                                    <td class="text-center">{{ item.added_date }}</td>
                                    <td class="text-center">{{ item.item_code }}</td>
                                    <td class="text-center" v-if="item[`item_name${lang.langname}`] != ''">{{ item[`item_name${lang.langname}`] }}<div v-html='item.description'></div></td>
                                    <td class="text-center" v-else>{{ item[`item_name_desc`] }}<div v-html='item.description'></div></td>
                                    <td class="text-center">{{ item.item_price }}</td>
                                    <td class="text-center">{{ item.qty }}</td>
                                    <td class="text-center">{{ item.total }}</td>
                                    <td class="text-center">{{ item.vat }}</td>
                                    <td class="text-center">{{ item.ftotal }}</td>
                                    <!-- <td class="text-center">{{ item.status }}</td> -->
                                    <td class="backRed text-center" style="cursor:pointer;" @click="deleteThis1('spare_part_not_invoice', item.id)">{{ lang.return }}</td>
                                </tr>
                            </tbody>
                        </b-table-simple>
                    </v-col>

                </v-row>
            </div>
        </div>
        <addSparePart ref="addSparePart" />
        <addService ref="addService" />
        <requestSparePart ref="requestSparePart" />
        <addInvoice ref="addInvoice" />
        <addBlackInvoice ref="addBlackInvoice" />
        <viewCardGallery ref="viewCardGall" />
        
    </div>
</template>

<script>
import axios from 'axios'
import addSparePart from './add_sparepart.vue'
import addService from './add_service.vue'
import requestSparePart from './request_spareparts.vue'
import addInvoice from './addInvoice.vue'
import addBlackInvoice from './addBlackInvoice.vue'
import viewCardGallery from '@/components/viewCardGallery.vue'
import {SnotifyPosition} from 'vue-snotify';
export default{
    components: {addSparePart,addService,requestSparePart,addBlackInvoice,addInvoice,viewCardGallery},
    data() {
        return {
            selectAllChecked: false,
            showtable: false,
            title: 'show path',
            id: 0,
            path_info: {},
            search: {
                sdate: '',
                edate: '',
            },
            source_id: 0,
            account_name: '',
            card: [],
            selectedItems: [],
            statuses: [],
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        pathStatus: function() {
            let t = [];
            for(let i=0;i<this.statuses.length;i++){
                t.push({text: this.statuses[i][`name_${this.lang.langname}`], value: this.statuses[i].value})
            }
            return t;
        }
    },
    watch: {
    // Update the "Select All" checkbox when individual checkboxes change
        selectedItems(newVal) {
        this.selectAllChecked = newVal.length === this.path_info.items_to_approve.length;
        }
    },
    methods: {
        changeStatus(){
            if(this.path_info.invoice_id && this.path_info.status == 5){
                this.$snotify.error(this.lang.final_invoice_required_before_close, this.lang.warning, {
                    timeout: 100000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                })
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','changePathStatus')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[pathid]',this.id);
            post.append('data[newstatus]',this.path_info.status);
            axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data){
                    this.statuses = response.data.results.data
                    this.closeTable();
                    this.$parent.getDashboard();
                }
            })
        },
        deleteThis1(type, id){
            this.$snotify.error(this.lang.confirm_return_item, this.lang.warning, {
                timeout: 100000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.agree, 
                        action: (toast) => {
                            this.$snotify.remove(toast.id); 
                            this.deleteThis(type,id);
                        } 
                    },
                    {
                        text: this.lang.cancel, 
                        action: (toast) => {
                            this.$snotify.remove(toast.id); 
                        } 
                    },
                ]
            })
            return false;
        },
        deleteThis(type, id){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','deleteItemsFromPath')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[itemid]',id);
            post.append('data[itemtype]',type);
            axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data){
                    this.statuses = response.data.results.data
                    this.closeTable();
                    this.$parent.getDashboard();
                }
            })
        },
        printInv(){
            window.open('/api/print.php?invid='+this.path_info.invoice_id, '_blank');
        },
        sendSelection(){
            if(this.selectedItems.length == 0){
                this.$snotify.error(this.lang.please_add_one_item_before_continue, this.lang.warning, {
                    timeout: 100000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                })
                return;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","sendSelectedItemsToCustomer");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[items]",JSON.stringify(this.selectedItems))
            post.append("data[pathid]",this.id)
            axios.post(this.$store.state.SAMCOTEC.r_path,post).then((response) => {
                if(response && response.data && response.data.results){
                    if(this.selectedItems.length == 0){
                        this.$snotify.error(this.lang.send_success, this.lang.warning, {
                            timeout: 100000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            position: SnotifyPosition.centerCenter,
                            buttons: [
                                {
                                    text: this.lang.close, 
                                    action: (toast) => {
                                        this.$snotify.remove(toast.id); 
                                    } 
                                },
                            ]
                        })
                        return;
                    }
                }
            })
        },
        sendCardToCustomer(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","sendCardToCustomer");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[items]",JSON.stringify(this.selectedItems))
            post.append("data[pathid]",this.id)
            axios.post(this.$store.state.SAMCOTEC.r_path,post).then((response) => {
                if(response && response.data && response.data.results){
                    if(this.selectedItems.length == 0){
                        this.$snotify.error(this.lang.job_card_sent_to_customer, this.lang.warning, {
                            timeout: 100000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            position: SnotifyPosition.centerCenter,
                            buttons: [
                                {
                                    text: this.lang.close, 
                                    action: (toast) => {
                                        this.$snotify.remove(toast.id); 
                                    } 
                                },
                            ]
                        })
                        return;
                    }
                }
            })
        },
        showAttached(){
            this.$refs.viewCardGall.card.cardid = this.path_info.card_id;
            this.$refs.viewCardGall.getImages();
        },
        toggleRowSelection(itemId) {
            const index = this.selectedItems.indexOf(itemId);
            if (index === -1) {
                // Add item to selection if not already selected
                this.selectedItems.push(itemId);
            } else {
                // Remove item from selection if already selected
                this.selectedItems.splice(index, 1);
            }

            // Update the "Select All" state
            this.selectAllChecked = this.selectedItems.length === this.path_info.items_to_approve.length;
        },

        selectAll() {
            if (this.selectAllChecked) {
                // Check all items
                this.selectedItems = this.path_info.items_to_approve.map(item => item.id);
            } else {
                // Uncheck all items
                this.selectedItems = [];
            }
        },

        async getCard(id) {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getCurretnCard");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[id]",id)
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path,post);
            this.card = response.data.results.data;
            this.cardType = response.data.results.data.rowType;
            this.work_type = response.data.results.data.work_type
            this.terms = response.data.results.terms;
            for(let i=0;i<this.card._cars.length;i++){
                this.currentCars.push({
                    text:this.card._cars[i].plate_number,value:this.card._cars[i].plate_number
                })
                if(i==0){
                    this.newrow.plate_number = this.card._cars[i].plate_number
                }
            }
        },
        addInvoice(){
            this.getCard(this.path_info.card_id);
            this.$refs.addInvoice.getNewInvoiceID();
            this.$refs.addInvoice.invoice.invtype = 2;
            if(this.card.carsjson.length == 0){
                this.card.carsjson = [{
                    c1: '',
                    c2: '',
                    c3: '',
                    text: '',
                    plate_number: '',
                    color: '',
                    model: '',
                    made_year: '',
                    workdes: '',
                    vin: '',
                    engine_meter: '',
                    next_oil_change: '',
                    brand: '',
                }]
            }else{
                let cars = [];
                for(let i=0;i<this.card.carsjson.length;i++){
                    let c = this.card.carsjson[i].plate_number.split(" ")
                    cars.push({
                        c1: c[0],
                        c2: c[1],
                        c3: c[2],
                        text: c[3],
                        plate_number: this.card.carsjson[i].plate_numebr,
                        color: this.card.carsjson[i].color,
                        model: this.card.carsjson[i].model,
                        made_year: this.card.carsjson[i].made_year,
                        workdes: '',
                        vin: this.card.carsjson[i].vin,
                        engine_meter: this.card.carsjson[i].engine_meter == 'undefined' ? "" : this.card.carsjson[i].engine_meter,
                        next_oil_change: '',
                        brand: '',
                    })
                }
                this.card.carsjson = cars;
            }
            this.$refs.addInvoice.cars = this.card.carsjson;
            
            this.$refs.addInvoice.customer.mobile = this.card.mobile;
            if(this.card.customer_type == 2 || this.card.customer_type == 3){
                this.$refs.addInvoice.company = this.card.company;
            }
            
            this.$refs.addInvoice.invoice.notes = "";
            this.$refs.addInvoice.customer = this.card.client;
            this.$refs.addInvoice.invoice.work_type = this.work_type;
            this.$refs.addInvoice.cctype = this.card.customer_type;
            this.$refs.addInvoice.invoice.discount = this.card.discount;
            this.$refs.addInvoice.invoice.customer_name = this.card.customer_name;
            this.$refs.addInvoice.invoice.customer_afforded = this.card.customer_afforded;
            this.$refs.addInvoice.company.po_number = this.card.po_number;
            this.$refs.addInvoice.company.po_date = this.card.po_date;
            
            this.$refs.addInvoice.tbrows = this.card.rows;
            if(typeof this.$refs.addInvoice.fillTbrowsItemCodes === 'function'){
                this.$refs.addInvoice.fillTbrowsItemCodes();
            }
            this.$refs.addInvoice.cardid = this.path_info.card_id;
            this.$refs.addInvoice.calcAll()
            this.$refs.addInvoice.customer.mobile = this.card.mobile;
            this.$refs.addInvoice.getName(0)
            this.$refs.addInvoice.changeCusType(parseFloat(this.card.customer_type) - 1 );
        },
        addBInvoice(){
            console.log("my refs", this.$refs);
            this.getCard(this.path_info.card_id);
            this.$refs.addBlackInvoice.getNewInvoiceID();
            this.$refs.addBlackInvoice.invoice.invtype = 2;

            if(this.card.carsjson.length == 0){
                this.card.carsjson = [{
                    c1: '',
                    c2: '',
                    c3: '',
                    text: '',
                    plate_number: '',
                    color: '',
                    model: '',
                    made_year: '',
                    workdes: '',
                    vin: '',
                    engine_meter: '',
                    next_oil_change: '',
                    brand: '',
                }]
            }else{
                let cars = [];
                for(let i=0;i<this.card.carsjson.length;i++){
                    let c = this.card.carsjson[i].plate_number.split(" ")
                    cars.push({
                        c1: c[0],
                        c2: c[1],
                        c3: c[2],
                        text: c[3],
                        plate_number: this.card.carsjson[i].plate_numebr,
                        color: this.card.carsjson[i].color,
                        model: this.card.carsjson[i].model,
                        made_year: this.card.carsjson[i].made_year,
                        workdes: '',
                        vin: this.card.carsjson[i].vin,
                        engine_meter: this.card.carsjson[i].engine_meter == 'undefined' ? "" : this.card.carsjson[i].engine_meter,
                        next_oil_change: '',
                        brand: '',
                    })
                }
                this.card.carsjson = cars;
            }
            this.$refs.addBlackInvoice.cars = this.card.carsjson;
            
            this.$refs.addBlackInvoice.customer.mobile = this.card.mobile;
            if(this.card.customer_type == 2 || this.card.customer_type == 3){
                this.$refs.addBlackInvoice.company = this.card.company;
            }
            
            this.$refs.addBlackInvoice.invoice.notes = "";
            this.$refs.addBlackInvoice.customer = this.card.client;
            this.$refs.addBlackInvoice.invoice.work_type = this.work_type;
            this.$refs.addBlackInvoice.cctype = this.card.customer_type;
            this.$refs.addBlackInvoice.invoice.discount = this.card.discount;
            this.$refs.addBlackInvoice.invoice.customer_name = this.card.customer_name;
            this.$refs.addBlackInvoice.invoice.customer_afforded = this.card.customer_afforded;
            this.$refs.addBlackInvoice.company.po_number = this.card.po_number;
            this.$refs.addBlackInvoice.company.po_date = this.card.po_date;
            
            this.$refs.addBlackInvoice.tbrows = this.card.rows;
            this.$refs.addBlackInvoice.cardid = this.path_info.card_id;
            this.$refs.addBlackInvoice.calcAll()
            this.$refs.addBlackInvoice.customer.mobile = this.card.mobile;
            this.$refs.addBlackInvoice.getName(0)
            this.$refs.addBlackInvoice.changeCusType(parseFloat(this.card.customer_type) - 1 );
        },
        addToStore(part_type){
            this.$refs.addSparePart.id = this.id;
            this.$refs.addSparePart.newrow = {
                itemid: 0,
                cardid: this.path_info.card_id,
                part_type: 1,
                invoied_type: part_type,
                approved: part_type == 2 ? 2 : 1,
                vat_type: 2,
                id: 0,
                item_id: '',
                item_code: '',
                item_name: '',
                qty: '',
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
            };
            this.$refs.addSparePart.sparePart = [];
        },
        requestSparePart(){
            this.$refs.requestSparePart.id = this.id;
            this.$refs.requestSparePart.newrow = {
                itemid: 0,
                cardid: this.path_info.card_id,
                part_type: 1,
                invoied_type: 1,
                approved: 1,
                vat_type: 2,
                id: 0,
                item_id: '',
                item_code: '',
                item_name: '',
                qty: '',
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
            };
            this.$refs.requestSparePart.sparePart = [];
        },
        addToService(){
            this.$refs.addService.id = this.id;
            this.$refs.addService.newrow = {
                itemid: 0,
                cardid: this.path_info.card_id,
                part_type: 1,
                invoied_type: 1,
                approved: 1,
                vat_type: 2,
                id: 0,
                item_id: '',
                item_code: '',
                item_name: '',
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: '',
                description: '',
            };
            this.$refs.addService.services = [];
            this.$refs.addService.getUsers();

        },
        printMe(){
            if(this.path_info.path_type == 1){
                window.open('/api/print.php?newcard'+this.path_info.card_id, '_blank');
            }
            else{
                window.open('/api/print.php?checkupid'+this.path_info.checkup_id, '_blank');
            }
        },
        getPathInfo(){
            this.showtable = true;
            this.title = this.lang.path_info_title;
            const post = new FormData();
            post.append('type','getCarPathInfo');
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append('auth',cook);
            post.append('data[id]',this.id);
            axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.path_info = response.data.results.data[0];
                    this.getCard(this.path_info.card_id)
                }
            })
        },
        closeTable(){
            this.showtable = false;
            this.tbrows = []
            this.search = {
                sdate: '',
                edate: '',
            }
            this.classid = 0
            this.account_name = ''
        },
        getStaticOptions() {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getStaticOptions')
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[phrase]','cardStatus')
            axios.post(this.$store.state.SAMCOTEC.r_path,post).then((response) => {
                if(response && response.data){
                    this.statuses = response.data.results.data
                } 
            }) 
        }
        
    },
    created() {
        // this.getStaticOptions();
    },
}
</script>
<style scoped>
.cusModal{
    position: fixed;
    background:#0000001a;
    top:0;
    left:0;
    bottom:0;
    right:0;
    z-index: 20000000;
    display:flex;
    justify-content: center;
    justify-items: center;
    align-items: center;;
}
.cusModalCont{
    position:relative;
    width:90%;
    height: 70vh;
    border:1px solid #bbb;
    background:#fff;
    box-shadow: 0px 1px 1px 1px #0000001a;
    border-radius: 5px;
}
.cusModalClose{
    position: absolute;
    top:2px;
    left:10px;
    background:red;
    color:#fff;
    border:1px solid #555;
    border:#ccc;
    border-radius: 5px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
}
.cusModalCloseL:hover{
    background: darkred;
}
.cusModalTitle{
    padding:5px;
    text-align:start;
    border-color: #bbb !important;
    border-bottom-color: #000 !important;
}
.cusModalBody{
    width:100%;
    overflow: auto;
    height:calc(70vh - 50px);
    max-height:calc(70vh - 50px);
    padding:5px;
    margin:5px 10px;
}

.eportBtn{
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
    display:flex;
    justify-content: center;
    justify-items: center;
    align-items: center;
}
.eportBtn div{
    padding:2px 5px;
    width:fit-content;
    font-size:.8rem;
    background:blue;
    margin-inline-start:5px;
    color:#fff;
    border-radius: 3px;
    text-align:center;
}
</style>

